import { Pipe, PipeTransform } from '@angular/core';
import { formatNumber } from '../../utils/utils';

@Pipe({
    name: 'formatNumber'
})
export class FormatNumberPipe implements PipeTransform {

    transform(value = 0): string {
        return formatNumber(value);
    }
}
